import { render, staticRenderFns } from "./deleteAffiliateWithdrawal.vue?vue&type=template&id=4d8e14b6"
import script from "./deleteAffiliateWithdrawal.vue?vue&type=script&lang=js"
export * from "./deleteAffiliateWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports